export default "__VITE_ASSET__D_pbn5_8__"